import useWorkspaceApiCall from 'hooks/useWorkspaceApiCall';
import { getLessonDetails } from 'api/services/lesson-service';
import { IGetLessonDetailsRequest } from '@api/models/request/IGetLessonDetailsRequest';
import { LessonDetails } from 'models/LessonDetails';
import { useCallback, useEffect, useState } from 'react';
import { useGetLessonImage } from 'hooks/useGetLessonImage';
import { LessonDetailsWithPhoto } from 'models/LessonDetailsWithPhoto';

export const useGetLessonDetails = (lessonId: string) => {
  const [lessonDetails, setLessonDetails] = useState<LessonDetailsWithPhoto>();
  const { callAPI, loading } = useWorkspaceApiCall<IGetLessonDetailsRequest, LessonDetails>(getLessonDetails);
  const { getLessonImageBase64 } =  useGetLessonImage();

  const fetchLessonDetails = useCallback(async () => {
    const response = await callAPI({ lessonId });
    if (response?.success && response.data) {
      const lessonImageBase64 = await getLessonImageBase64(lessonId);

      setLessonDetails({...response.data, photoBase64: lessonImageBase64});
    }
    return response;
  }, [callAPI, lessonId]);

  useEffect(() => {
    fetchLessonDetails();
  }, [fetchLessonDetails]);

  return {
    lessonDetails,
    fetchLessonDetails,
    fetchLessonDetailsPending: loading
  };
};